module.exports = __webpack_public_path__ + "img/nigiris.9271ad3f.jpg";